export const REQUEST = 'REQUEST'
export const REQUEST_LIMIT = 'REQUEST_LIMIT'
export const CHANGE_CURRENT_SPACE = 'CHANGE_CURRENT_SPACE'
export const SELECT_EDIT_SPACE_MEMBER = 'SELECT_EDIT_SPACE_MEMBER'

export const ADD_MEMBER_TO_SPACE = 'spaces/members/ADD'
export const ADD_MEMBER_TO_SPACE_SUCCESS = `${ADD_MEMBER_TO_SPACE}_SUCCESS`
export const ADD_MEMBER_TO_SPACE_ERROR = `${ADD_MEMBER_TO_SPACE}_ERROR`

export const FETCH_USERS_PAGINATED = 'organization/users'

export const FETCH_USER = 'organization/user'
export const FETCH_USER_SUCCESS = `${FETCH_USER}_SUCCESS`
export const FETCH_USER_ERROR = `${FETCH_USER}_ERROR`
